import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SeekerRequestMoreComponent } from '../seeker-request-more/seeker-request-more.component';
import {
    PopoverController,
    IonContent,
    Platform,
    IonRefresher,
    ModalController,
    AlertController,
    NavController
} from '@ionic/angular';
import { v4 as uuid } from 'uuid';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import { PtyLdService } from 'src/app/services/pty-ld.service';
import { Events } from '../../services/events.service';
import { SeekerRequestTemplatesComponent } from '../seeker-request-templates/seeker-request-templates.component';
import { SeekerRequestResourcesComponent } from '../seeker-request-resources/seeker-request-resources.component';
import { SeekerUsefulLinksComponent } from '../seeker-useful-links/seeker-useful-links.component';
import { SeekerRequestDocumentComponent } from 'src/app/components/seeker-request-document/seeker-request-document.component';
import { environment } from 'src/environments/environment';
import {TranslationService} from "../../services/translation.service";

@Component({
    selector: 'app-broadcast-disciples-messages',
    templateUrl: './broadcast-disciples-messages.component.html',
    styleUrls: ['./broadcast-disciples-messages.component.scss'],
})
export class BroadcastDisciplesMessagesComponent implements OnInit {
    selectedItems: any;

    chatMessage: any = '';
    subject_line: any = '';
    userTemplates: any = [];
    textLimit = 2000;

    constructor(
        private modalCtrl: ModalController,
        private poCtrl: PopoverController,
        private ws: PtyWsService,
        private ld: PtyLdService,
        public alertController: AlertController,
        private changeDetector: ChangeDetectorRef,
        private _translationService: TranslationService
    ) {
    }

    ngOnInit() {
        this.getData();
        this.loadTemplates();
    }

    getData() {
    }

    async dismiss(data: any = '') {
        await this.modalCtrl.dismiss(data);
    }

    loadTemplates() {
        let self = this;
        self.ld.showLoading(true).then(() => {
            self.ws.invokeURL('user_templates', {}).subscribe((result: any) => {
                if (result.error === 0) {
                    this.userTemplates = result.templates;
                }
                self.ld.showLoading(false);
            });
        });
    }

    async showMore(ev: any) {
        const self = this;
        const popover = await self.poCtrl.create({
            component: SeekerRequestMoreComponent,
            event: ev,
            componentProps: {
                is_multiple: true
            },
            translucent: true
        });

        popover.onDidDismiss().then((option: any) => {
            switch (option.data) {
                case 'templates':
                    self.showTemplates(ev);
                    break;
                case 'resources':
                    self.showResources(ev);
                    break;
                case 'links':
                    self.showUsefulLinks(ev);
                    break;
                case 'documents':
                    self.showDocuments(ev);
                    break;
            }
        });
        return await popover.present();
    }

    async showDocuments(ev: any) {
        const self = this;
        const modalCtrl = await self.modalCtrl.create({
            component: SeekerRequestDocumentComponent,
            componentProps: {
                templates: self.userTemplates
            }
        });

        modalCtrl.onDidDismiss().then((option: any) => {
            if (option.data !== undefined) {
                this.checkDuplicateDocument(option.data);

            }

        });

        return await modalCtrl.present();
    }

    checkDuplicateDocument(data) {
        const self = this;
        self.ws.invokeURL('check_duplicate_document', {
            url: data.url,
            conversation_uuid: this.selectedItems[0].conversation_uuid
        }).subscribe((result: any) => {
            if (result.error === 0) {
                if (result.result.length > 0) {
                    this.showDuplicateDocument(data);
                } else {
                    this.sendAttachmentMessage(data);
                }
            }
        }, (err: any) => {
            console.error('Error taking conversation', err);
        });

    }


    sendAttachmentMessage(data) {
        const self = this;
        const timeStamp = new Date();
        const localUUID = uuid();
        let url: any;
        let message: any;
        const token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        let messageData: any;

        if (data.Location) {
            url = data.Location;
        } else if (data.url) {
            url = data.url;
        } else {
            url = data;
        }

        // Preparing URL
        message = environment.WS_END_POINT + 'message-attachments?req_token=' + token;
        this.chatMessage += ' ' + message;


        self.ws.invokeURL('send_message', {
            conversation_uuid: this.selectedItems[0].conversation_uuid,
            message: message,
            message_type: 'text'
        }).subscribe((result: any) => {

            self.changeDetector.detectChanges();

            const timeLineMessage = 'Attachment shared ' + message;
            const messageParse = this.urlify(timeLineMessage);
            //  this.addTimelineItem(messageParse);
            this.attachmentEntry(url, token, result.result);
        }, (err: any) => {
            console.error('Error taking conversation', err);
            self.ld.showToast(this._translationService.translate('UnknownError'));
        });


    }


    attachmentEntry(url, token, message) {
        const self = this;

        const messageData = message.result;

        self.ws.invokeURL('prepare_attachment_url', {
            url: url,
            req_token: token,
            message_uuid: messageData.uuid,
            seeker_uuid: self.selectedItems[0].seeker_uuid,
            conversation_uuid: self.selectedItems[0].uuid
        }).subscribe((resp: any) => {
            if (resp.error === 0) {
                // console.log(resp);
            } else {
                self.ld.showToast(this._translationService.translate('UnknownError'));
            }
        }, (err: any) => {
            self.ld.showToast(this._translationService.translate('UnknownError'));
        });
    }


    urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        let new_text = text.replace(urlRegex, function (url) {
            return '<a target="_blank" href="' + url + '">' + url + '</a>';
        });
        return new_text;
    }


    async showDuplicateDocument(data) {
        const alert = await this.alertController.create({
            header: this._translationService.translate('DuplicateDocument'),
            message: this._translationService.translate('AlreadySharedDocument'),
            buttons: [
                {
                    text: this._translationService.translate('DontSend'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (blah) => {
                        // console.log(blah);
                    }
                }, {
                    text: this._translationService.translate('SendDocument'),
                    handler: () => {
                        //   this.sendAttachmentMessage(data);
                    }
                }
            ]
        });

        await alert.present();
    }


    async showTemplates(ev: any) {
        const self = this;
        const modalCtrl = await self.modalCtrl.create({
            component: SeekerRequestTemplatesComponent,
            componentProps: {
                templates: self.userTemplates
            }
        });

        modalCtrl.onDidDismiss().then((option: any) => {
            if (option.data.object !== null) {
                this.addText(option.data.object);
            }
        });

        return await modalCtrl.present();
    }

    async addText(template: any) {
        if (template.message_template.length > this.textLimit) {
            const alert = await this.alertController.create({
                header: this._translationService.translate('MessageLong'),
                message: this._translationService.translate('MessageExceeds'),
                buttons: [
                    this._translationService.translate('Okay')
                ]
            });
            await alert.present();
        }
        this.chatMessage += template.message_template;
    }

    async showResources(ev: any) {
        const self = this;
        const modalCtrl = await self.modalCtrl.create({
            component: SeekerRequestResourcesComponent,
            componentProps: {
                templates: self.userTemplates
            }
        });

        modalCtrl.onDidDismiss().then((option: any) => {
            if (option.data !== undefined) {
                const test = option.data;
                this.chatMessage = test.trim();
            }
        });

        return await modalCtrl.present();
    }

    async showUsefulLinks(ev: any) {
        const self = this;
        const modalCtrl = await self.modalCtrl.create({
            component: SeekerUsefulLinksComponent,
            componentProps: {
                templates: self.userTemplates
            }
        });

        modalCtrl.onDidDismiss().then((option: any) => {
            if (option.data !== undefined) {
                self.sendUserfulLink(option.data.object);
            }
        });

        return await modalCtrl.present();
    }

    sendUserfulLink(template: any) {
        this.chatMessage += template.url;
    }

    async sendMessage() {
        if (this.chatMessage === '' || this.chatMessage.length > this.textLimit) {
            const alert = await this.alertController.create({
                header: this._translationService.translate('MessageLong'),
                message: this._translationService.translate('MessageExceeds'),
                buttons: [
                    this._translationService.translate('Okay')
                ]
            });
            await alert.present();
            return;
        }
        const self = this;
        const message = this.chatMessage;
        this.chatMessage = '';

        let count: number = 0;
        self.ld.showLoading(true).then(() => {
            this.selectedItems.forEach(e => {
                // sending message
                self.ws.invokeURL('send_message', {
                    conversation_uuid: e.conversation_uuid,
                    subject: this.subject_line,
                    message: message,
                    message_type: 'text'
                }).subscribe((result: any) => {

                    if (result.error === 0) {
                        count = count + 1;
                        this.dismiss();

                    }
                });
            });
            self.ld.showLoading(false);
        });
    }
}
